import { useParams } from "react-router-dom";
import Header from "../components/Header";
import CreateForm from "./components/CreateForm";

function CreateLectureVouchers() {
    const { courseId } = useParams();

    let pagesLinks = [
        {
            name: "أنشاء أكود",
            link: `/admin/vouchers`,
        },
        { name: "الصفحة الرئيسية", link: `/` },
        {
            name: "الفصول الدراسية",
            link: `/admin/courses`,
        },
        {
            name: "المحاضرات",
            link: `/admin/courses/${courseId}/lectures`,
        },
    ];

    return (
        <div>
            <Header
                pageName="أنشاء أكود"
                pages={pagesLinks}
                className="text-2xl"
            />
            <CreateForm />
        </div>
    );
}

export default CreateLectureVouchers;
